// extracted by css-extract-rspack-plugin
export default {"illustration":"illustration-EyRgwk","spot":"spot-GiPJ8O illustration-EyRgwk","lg":"lg-AeNnkm","spotHero":"spotHero-no43i6 illustration-EyRgwk"};